import { useState, useRef } from "react";
import { FiCopy, FiCheck, FiDownload } from "react-icons/fi";
import { copyTable, downloadTable } from "../utils/table-utils";

export const TableRoot = ({ children, className, ...props }: any) => {
  const [isCopied, setIsCopied] = useState(false);
  const tableRef = useRef<HTMLDivElement>(null);
  const downloadRef = useRef<HTMLAnchorElement>(null);

  const handleTableCopy = async () => {
    try {
      const copyStatus = await copyTable(tableRef);
      setIsCopied(copyStatus);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } catch {
      setIsCopied(false);
    }
  };

  return (
    <div ref={tableRef}>
      <div className={`flex justify-end p-1 gap-2.5 ${className || ""}`}>
        <div className="tooltip tooltip-left" data-tip="Download">
          <FiDownload
            size={20}
            className="cursor-pointer rounded p-0.5 transition-all duration-300 hover:bg-base-300"
            onClick={() => downloadTable(tableRef, downloadRef)}
          />
        </div>
        <a
          ref={downloadRef}
          className="hidden"
        />
        <div className="tooltip tooltip-left" data-tip={isCopied ? "Copied" : "Copy"}>
          {isCopied ? (
            <FiCheck
              size={20}
              className="cursor-pointer rounded p-0.5 transition-all duration-300"
            />
          ) : (
            <FiCopy
              size={20}
              className="cursor-pointer rounded p-0.5 transition-all duration-300 hover:bg-base-300"
              onClick={handleTableCopy}
            />
          )}
        </div>
      </div>
      <table
        className={`table table-zebra w-full whitespace-pre-wrap break-words max-w-full ${className || ""}`}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

export const TableHeader = ({ children }: any) => (
  <thead>{children}</thead>
);

export const TableBody = ({ children }: any) => (
  <tbody>{children}</tbody>
);

export const TableRow = ({ children }: any) => (
  <tr>{children}</tr>
);

export const TableHead = ({ children }: any) => (
  <th className="font-semibold">{children}</th>
);

export const TableCell = ({ children }: any) => (
  <td>{children}</td>
);
